import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/step11.png'
import _imports_1 from '@/assets/icon/step1.png'
import _imports_2 from '@/assets/icon/step12.png'
import _imports_3 from '@/assets/icon/step.png'
import _imports_4 from '@/assets/icon/step13.png'
import _imports_5 from '@/assets/icon/step14.png'


const _withScopeId = n => (_pushScopeId("data-v-6d128696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type-step" }
const _hoisted_2 = { class: "type-step-c" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "退款进度", -1))
const _hoisted_4 = { class: "step" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-item-first-left step-item-first-left-first" }, null, -1))
const _hoisted_6 = { class: "step-item-first-center" }
const _hoisted_7 = {
  key: 0,
  class: "center-img",
  src: _imports_0
}
const _hoisted_8 = {
  key: 1,
  class: "center-img",
  src: _imports_1
}
const _hoisted_9 = { class: "step-item-first-center" }
const _hoisted_10 = {
  key: 0,
  class: "center-img",
  src: _imports_2
}
const _hoisted_11 = {
  key: 1,
  class: "center-img",
  src: _imports_1
}
const _hoisted_12 = {
  key: 2,
  class: "center-img",
  src: _imports_3
}
const _hoisted_13 = {
  key: 0,
  class: "step-item"
}
const _hoisted_14 = { class: "step-item-first-center" }
const _hoisted_15 = {
  key: 0,
  class: "center-img",
  src: _imports_4
}
const _hoisted_16 = {
  key: 1,
  class: "center-img",
  src: _imports_1
}
const _hoisted_17 = {
  key: 2,
  class: "center-img",
  src: _imports_3
}
const _hoisted_18 = { class: "step-item-first-center" }
const _hoisted_19 = {
  key: 0,
  class: "center-img",
  src: _imports_5
}
const _hoisted_20 = {
  key: 1,
  class: "center-img",
  src: _imports_1
}
const _hoisted_21 = {
  key: 2,
  class: "center-img",
  src: _imports_3
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-item-first-right step-item-first-right-end" }, null, -1))
const _hoisted_23 = { class: "step-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "提交退款申请", -1))
const _hoisted_25 = { class: "text-time" }
const _hoisted_26 = {
  key: 0,
  class: "text-time"
}
const _hoisted_27 = {
  key: 0,
  class: "step-text-item"
}
const _hoisted_28 = {
  key: 0,
  class: "text-time"
}
const _hoisted_29 = {
  key: 1,
  class: "text-time text-time-red"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yk_gantanhao_fill" }, null, -1))
const _hoisted_31 = {
  key: 2,
  class: "text-time text-time-red"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yk_gantanhao_fill" }, null, -1))
const _hoisted_33 = {
  key: 3,
  class: "text-time text-time-blue"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yk_gantanhao_fill" }, null, -1))
const _hoisted_35 = {
  key: 4,
  class: "text-time text-time-red"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yk_gantanhao_fill" }, null, -1))
const _hoisted_37 = {
  key: 0,
  class: "text-time"
}

import { inject, withDefaults } from "vue"
import dateFormat from "@/utils/dateFormat"

interface Props {
  status: number
  service_type: number
  ctime: number
  utime: number
  ftime: number
  rtime: number
  signed: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PostStep',
  props: {
    status: { default: 2 },
    service_type: { default: 2 },
    ctime: { default: 0 },
    utime: { default: 0 },
    ftime: { default: 0 },
    rtime: { default: 0 },
    signed: { default: 0 }
  },
  setup(__props: any) {

const { signed, status, service_type, ctime, utime, ftime, rtime } = __props as { status: number, service_type: number, ctime: number, utime: number, ftime: number, rtime: number, signed: number };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["step-item", { 'step-item-c': service_type != 2 }])
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (status == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : (_openBlock(), _createElementBlock("img", _hoisted_8))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["step-item-first-right", { 'ba-color': status > 0 }])
          }, null, 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step-item", { 'step-item-c': service_type != 2 }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["step-item-first-left", { 'step-item-first-left-now': status > 0 }])
          }, null, 2),
          _createElementVNode("div", _hoisted_9, [
            (status == 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true),
            (status > 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            (status < 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["step-item-first-right", { 'step-item-first-left-now': status > 1 }])
          }, null, 2)
        ], 2),
        (service_type == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", {
                class: _normalizeClass(["step-item-first-left", { 'step-item-first-left-now': status > 1 }])
              }, null, 2),
              _createElementVNode("div", _hoisted_14, [
                (status == 2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                  : _createCommentVNode("", true),
                (status > 2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                  : _createCommentVNode("", true),
                (status < 2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["step-item-first-right", { 'step-item-first-left-now': status > 2 }])
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["step-item step-item-end", { 'step-item-c': service_type != 2 }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["step-item-first-left", { 'step-item-first-left-now': status > 2 }])
          }, null, 2),
          _createElementVNode("div", _hoisted_18, [
            (status == 3)
              ? (_openBlock(), _createElementBlock("img", _hoisted_19))
              : _createCommentVNode("", true),
            (status > 3)
              ? (_openBlock(), _createElementBlock("img", _hoisted_20))
              : _createCommentVNode("", true),
            (status < 3)
              ? (_openBlock(), _createElementBlock("img", _hoisted_21))
              : _createCommentVNode("", true)
          ]),
          _hoisted_22
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", {
          class: _normalizeClass(["step-text-item", { 'step-text-item-t': service_type != 2 }])
        }, [
          _hoisted_24,
          _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(dateFormat).dateFormat(ctime * 1000, "yyyy-MM-dd hh:mm:ss")), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step-text-item", { 'step-text-item-t': service_type != 2 }])
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(["text-title", { 'text-color': !utime || status < 1 }])
          }, " 退款申请审核 ", 2),
          (utime > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_unref(dateFormat).dateFormat(utime * 1000, "yyyy-MM-dd hh:mm:ss")), 1))
            : _createCommentVNode("", true)
        ], 2),
        (service_type == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-title", { 'text-color': !utime || status < 2 }])
              }, " 买家退货 ", 2),
              rtime
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_unref(dateFormat).dateFormat(rtime * 1000, "yyyy-MM-dd hh:mm:ss")), 1))
                : _createCommentVNode("", true),
              (status == 2 && !rtime)
                ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                    _hoisted_30,
                    _createTextVNode(" 请您尽快将货物寄出！ ")
                  ]))
                : _createCommentVNode("", true),
              (rtime && signed == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode(" 平台已联系物流,待收到货物后将钱款原路退回 ")
                  ]))
                : _createCommentVNode("", true),
              (rtime && signed == 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(" 已签收 ")
                  ]))
                : _createCommentVNode("", true),
              (rtime && signed == 2)
                ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode(" 货物验收不通过 ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["step-text-item", { 'step-text-item-t': service_type != 2 }])
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(["text-title", { 'text-color': !ftime }])
          }, "退款成功", 2),
          (ftime&&status == 3)
            ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_unref(dateFormat).dateFormat(ftime * 1000, "yyyy-MM-dd hh:mm:ss")), 1))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}
}

})